export enum OrderSourceEnum {
  QUICK_BUY = 'QUICK_BUY',
  OTC = 'OTC',
  PARENT_ORDER = 'PARENT_ORDER',
}
